class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelector("#CartDrawer-Overlay").addEventListener(
      "click",
      this.close.bind(this)
    );
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble");
    if (!cartLink) return;

    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");
    cartLink.addEventListener("click", (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
      this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add("animate", "active");
    });

    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.classList.contains("is-empty")
          ? this.querySelector(".drawer__inner-empty")
          : document.getElementById("CartDrawer");
        const focusElement =
          this.querySelector(".drawer__inner") ||
          this.querySelector(".drawer__close");
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add("overflow-hidden");
  }

  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute(
        "aria-controls",
        cartDrawerNote.nextElementSibling.id
      );
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open")
      );
    });

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector(".drawer__inner").classList.contains("is-empty") &&
      this.querySelector(".drawer__inner").classList.remove("is-empty");
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener(
        "click",
        this.close.bind(this)
      );
      // this.open();
    });
  }

  renderContentsCustom(parsedState, openDrawer) {
    document
      .querySelector("#CartDrawer .drawer__inner")
      .classList.contains("is-empty") &&
      document
        .querySelector("#CartDrawer .drawer__inner")
        .classList.remove("is-empty");
    //this.productId = parsedState.id;
    document
      .querySelector("cart-drawer")
      .getSectionsToRender()
      .forEach((section) => {
        const sectionElement = section.selector
          ? document.querySelector(section.selector)
          : document.getElementById(section.id);
        console.log(sectionElement, "test2");

        sectionElement.innerHTML = document
          .querySelector("cart-drawer")
          .getSectionInnerHTML(parsedState[section.id], section.selector);
      });

    document.getElementsByClassName("drawer")[0].classList.remove("is-empty");

    setTimeout(() => {
      document
        .querySelector("#CartDrawer #CartDrawer-Overlay")
        .addEventListener("click", this.close.bind(this));
      if (openDrawer) {
        this.open();
      }
    });
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "#CartDrawer",
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer__inner",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);

//{% comment %}(11-11-2025) plus and minus logic added id="product-varient-id" {% endcomment %}
// Init logic
// function toggleAtcd(showQtyBar, qty = 0) {
//   const bar = document.querySelector("#pdp-add-to-cart-fn");
//   const cta = document.querySelector("#pdp-add-to-cart-fnp");
//   if (showQtyBar) {
//     const q = Math.max(1, parseInt(qty, 10) || 1);
//     const v = bar?.querySelector(".qty-value");
//     if (v) v.textContent = String(q);
//     const hid = bar?.querySelector('input[name="quantity"]');
//     if (hid) hid.value = String(q);
//     if (bar) bar.style.display = "flex";
//     if (cta) cta.style.display = "none";
//   } else {
//     const q = Math.max(1, parseInt(1));
//     const v = bar?.querySelector(".qty-value");
//     if (v) v.textContent = String(q);
//     const hid = bar?.querySelector('input[name="quantity"]');
//     if (hid) hid.value = String(q);
//     if (bar) bar.style.display = "none";
//     if (cta) cta.style.display = "block";
//   }
//   // console.log('toggleAtc');
// }
// applyCartLevelDiscountd = () => {
//   // console.log("working find");
// };
// document.addEventListener("DOMContentLoaded", function () {
//   const applyWithDelayd = () => setTimeout(applyCartLevelDiscountd, 200);

//   applyCartLevelDiscountd();

//   // Listen to quantity changes
//   document
//     .querySelectorAll(".quantity__input")
//     .forEach((input) => input.addEventListener("change", applyWithDelayd));
//   document
//     .querySelectorAll(".quantity__button")
//     .forEach((btn) => btn.addEventListener("click", applyWithDelayd));

//   // new code for pdp cart
//   async function getCartCount() {
//     const cart = await fetch("/cart.js", {
//       headers: { Accept: "application/json" },
//       credentials: "same-origin",
//     }).then((r) => r.json());
//     return { cart_count: Number(cart?.item_count || 0), cart_item: cart.items };
//   }
//   //new code for pdp cart

//   // Watch for dynamic cart changes
//   const target = document.querySelector(
//     ".cart-items, #CartDrawer, .cart-drawer"
//   );
//   if (target) {
//     const observer = new MutationObserver(async () => {
//       //start code here for pdp code
//       const isProductPage = document.body.dataset.template === "product";
//       if (isProductPage) {
//         const count_object = await getCartCount();
//         // console.log("test click",count_object.cart_item)
//         const variantId =
//           document
//             .querySelector("#product-varient-id, .product-variant-id-bottom")
//             ?.value?.trim() || null;
//         // console.log('Product ID:', variantId);
//         const totalQtyForVariant = (items, variantId) =>
//           items.reduce(
//             (sum, item) =>
//               String(item.variant_id) === String(variantId)
//                 ? sum + (Number(item.quantity) || 0)
//                 : sum,
//             0
//           );
//         // usage
//         const matchedCount = totalQtyForVariant(
//           count_object.cart_item,
//           variantId
//         );
//         // console.log('matchedCount', matchedCount);
//         const el = document.querySelector(".qty-bar .qty-value");
//         if (el) el.textContent = String(matchedCount);
//         toggleAtcd(matchedCount > 0, matchedCount);
//       }
//       //end code here for pdp code
//       applyWithDelayd();
//     });

//     observer.observe(target, {
//       childList: true,
//       subtree: true,
//     });
//   }
// });
//{% comment %}(11-11-2025) plus and minus logic added id="product-varient-id" {% endcomment %}
